import { ActionType, createAction, createAsyncAction } from "typesafe-actions";

import { AnyEntity } from "@mapmycustomers/shared/types/entity";

import { DrillDownListFetcherPayload } from "@app/scene/dashboard/types/DrillDownListFetcher";
import DrillDownViewState from "@app/scene/dashboard/types/DrillDownViewState";
import RecordsPastDueCardConfiguration from "@app/types/dashboard/cards/recordsPastDue/RecordsPastDueCardConfiguration";
import Scope from "@app/types/dashboard/Scope";

import RecordsPastDueCardData from "./RecordsPastDueCardData";

export const fetchRecordsPastDueCardData = createAction("@dashboard/fetchRecordsPastDueCardData")<{
  callback: (data: RecordsPastDueCardData) => void;
  configuration: RecordsPastDueCardConfiguration;
  failureCallback?: () => void;
  scope?: Scope;
}>();

export const showRecordsPastDueDrillDown = createAsyncAction(
  "@dashboard/showRecordsPastDueCardDrillDownModal/request",
  "@dashboard/showRecordsPastDueCardDrillDownModal/success",
  "@dashboard/showRecordsPastDueCardDrillDownModal/failure"
)<
  {
    configuration: RecordsPastDueCardConfiguration;
    scope: Scope;
  },
  { viewState: DrillDownViewState },
  unknown
>();

export const hideRecordsPastDueDrillDown = createAction(
  "@dashboard/hideRecordsPastDueCardDrillDownModal"
)<void>();

export const fetchRecordsPastDueCardDrillDownData = createAsyncAction(
  "@dashboard/fetchRecordsPastDueCardDrillDownData/request",
  "@dashboard/fetchRecordsPastDueCardDrillDownData/success",
  "@dashboard/fetchRecordsPastDueCardDrillDownData/failure"
)<
  DrillDownListFetcherPayload<AnyEntity>,
  {
    totalFilteredRecords: number;
    totalRecords: number;
  },
  unknown
>();

export const applyRecordsPastDueDrillDownListViewSettings = createAction(
  "@dashboard/applyRecordsPastDueDrillDownListViewSettings"
)<Partial<DrillDownViewState>>();

export const exportRecordsPastDueCardDrillDownData = createAction(
  "@dashboard/exportRecordsPastDueCardData"
)<{
  configuration: RecordsPastDueCardConfiguration;
  scope: Scope;
}>();

export type RecordsPastDueCardActions = ActionType<
  | typeof applyRecordsPastDueDrillDownListViewSettings
  | typeof exportRecordsPastDueCardDrillDownData
  | typeof fetchRecordsPastDueCardData
  | typeof fetchRecordsPastDueCardDrillDownData
  | typeof hideRecordsPastDueDrillDown
  | typeof showRecordsPastDueDrillDown
>;
